import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { HabitList } from '../components/habits/habit-list';
import { isAuthenticated } from '../utils/auth';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (!isAuthenticated()) throw redirect({ to: '/info' });
  },
  component: HomeComponent,
});

function HomeComponent() {
  return (
    <main
      aria-label='Habits'
      className='mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-10'
    >
      <div className='mb-8 flex justify-end'>
        <Link
          to='/habits/create'
          className='inline-flex items-center rounded-xl bg-c-accent px-4 py-2.5 font-semibold text-[#2f2418] shadow-sm transition-all hover:-translate-y-0.5 hover:bg-c-accent-hover hover:shadow-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c-accent motion-reduce:transform-none'
        >
          + Create Habit
        </Link>
      </div>
      <HabitList />
    </main>
  );
}
